<template>
    <div class="group-page-chats">
        <group-page-header title="Group Chats" :left-part-size="6" :right-part-size="6">
            <span slot="additionalButtons">
                <vue-folder-button
                        v-if="viewerCanCreateConversations"
                        text="Start New"
                        icon-class="fa-plus"
                        @click.native="startConversation"
                        tabindex="0"
                        role="button"
                        aria-label="Start New"
                ></vue-folder-button>
                <vue-folder-button
                        icon-class="fa-check"
                        text="Mark all as read"
                        @click.native="markAllAsRead"
                        tabindex="0"
                        role="button"
                        aria-label="Mark all as read"
                ></vue-folder-button>
            </span>
        </group-page-header>
        <div class="row">
            <div class="col-sm-6 group-page-chats__header">
            </div>
            <div class="col-sm-6 text-right">
                <vue-search-input
                        @search="onSearch"
                        @cancel="onSearchCancel"
                ></vue-search-input>
            </div>
        </div>
        <group-page-chats-chat
                :chat="chat"
                v-for="chat in results"
                :key="chat.id"

                @leaveChat="leaveChat(chat)"
                @followChat="followChat(chat)"
        ></group-page-chats-chat>

        <div class="row margin-15-top" v-if="!loadingBlock&&(results.length===0)">
            <div class="col-sm-12">
                <div class="alert alert-info">
                    <span v-if="query">There not any Chats matching your criteria in this Group</span>
                    <span v-else>There not any Chats have been created in this Group</span>
                </div>
            </div>
        </div>

        <div v-infinite-scroll="loadMore"></div>
    </div>
</template>

<script>
    import InfiniteScrollMixin from "../../../vue/mixins/InfiniteScrollMixin";
    import Vue from "vue";
    import GroupResource from "../groups/group_resource";
    import {mapGetters} from "vuex";
    import GroupPageChatsChat from "./GroupPageChatsChat";
    import GroupPageHeader from "./common/GroupPageHeader";
    import {CurrentUserClass} from "shared/CurrentUser";
    import {simplePopupFactory} from "shared/simple_popups/simplePopupFactory";
    import _ from "lodash";

    export default {
        name: "GroupPageChats",
        components: {GroupPageHeader, GroupPageChatsChat},
        mixins: [InfiniteScrollMixin],
        data() {
            return {};
        },
        computed: {
            ...mapGetters('groupPage', {group: 'group'}),
            viewerCanCreateConversations() {
                return new CurrentUserClass().has_permission('message-groups');
            },
        },
        methods: {
            getListEndpoint() {
                const $http = Vue.getAngularModule('$http');
                return GroupResource($http).get_group_conversations;
            },
            getListEndpointArgs() {
                return [this.group.id];
            },
            startConversation() {
                const $rootScope = Vue.getAngularModule('$rootScope');
                const $http = Vue.getAngularModule('$http');
                simplePopupFactory.simple_text_input_popup(
                    'New Chat',
                    'Give this Chat a name?',
                    'Create Chat',
                )
                    .then(name => {
                        $rootScope.show_dimmer();
                        return GroupResource($http).create_conversation(this.group.id, name);
                    }, () => new Promise(() => {
                    }))
                    .then(resp => {
                        document.location.href = this.$options.filters.backHrefQuery(resp.data.link);
                    }, err => {
                        $rootScope.hide_dimmer();
                        Vue.notifications.error(err || 'Error');
                    });
            },
            markAllAsRead() {
                const $rootScope = Vue.getAngularModule('$rootScope');
                const $http = Vue.getAngularModule('$http');
                $rootScope.show_dimmer();
                GroupResource($http).mark_group_conversations_as_read(this.group.id)
                    .then(resp => {
                        for (const chat of this.results) {
                            chat.unread_count = 0;
                        }
                        Vue.notifications.success('All Chats are mark as read');
                        $rootScope.$broadcast('conversations_unread_count_changed', resp.data);
                    })
                    .finally($rootScope.hide_dimmer);
            },
            followChat(chat) {
                const $rootScope = Vue.getAngularModule('$rootScope');
                const $http = Vue.getAngularModule('$http');
                $rootScope.show_dimmer();
                GroupResource($http).follow_group_chat(this.group.id, chat.id)
                    .then(resp => {
                        Vue.notifications.success('You are following this Chat now');
                        chat.following = true;
                    })
                    .finally(() => {
                        $rootScope.hide_dimmer();
                    });
            },
            leaveChat(chat) {
                const $rootScope = Vue.getAngularModule('$rootScope');
                const $http = Vue.getAngularModule('$http');
                $rootScope.show_dimmer();
                GroupResource($http).unfollow_group_chat(this.group.id, chat.id)
                    .then(resp => {
                        Vue.notifications.success('You are not following this Chat anymore');
                        chat.following = false;
                    })
                    .finally(() => {
                        $rootScope.hide_dimmer();
                    });
            },
        }

    };
</script>

<style scoped lang="scss">
  @import "commonStyle";

  .group-page-chats {
    &__header {
      font-size: 24px;
    }
  }
</style>
